import { useConfigsApi } from "src/api/useConfigsApi";

// These are the features defined in rome2rio-core that can be used in the app.
// They MUST be added to the frontendFeatures list in FeaturePolicy to be available
// in the frontend.
//
// See:
// - https://github.com/rome2rio/rome2rio-core/blob/main/rome2rio.common/Features/FeatureEnum.cs
// - https://github.com/rome2rio/rome2rio-core/blob/main/rome2rio.common/Features/FeaturePolicy.cs#L195
//
const FeatureFlagList = [
  "ShowDebug",
  "HotelPromoDriveSegment",
  "RefreshAdUnits",
  "DriveRoutes",
] as const;
export type FeatureFlag = (typeof FeatureFlagList)[number];

// export function useFeatureFlag(name: FeatureFlag): boolean | undefined {
//   const features = useFeatureFlagConfig();
//   return features?.[name];
// }

export function useFeatureFlagConfig(): Record<string, boolean> | undefined {
  const features = useConfigsApi((data) =>
    data.featureFlags.reduce(
      (acc, flag) => {
        acc[flag.featureName] = flag.isEnabled;
        return acc;
      },
      {} as Record<string, boolean>,
    ),
  );

  return features.data;
}
